<template>
    <perfect-scrollbar class="d-flex flex-column flex-grow-1" :options="opsScroll">
    <b-card header-tag="header"
            footer-tag="footer">
        <div class="d-flex">
          <b-button class="flex-grow-1" @click="refreshDeliveries()">Обновить список</b-button>
          <b-button
            v-if="currentDeliveryOrders.length"
            variant="primary"
            class="flex-grow-1 ml-2"
            @click="createYaMapRoute()"
          >
            Построить маршрут
          </b-button>
        </div>
        <h5 slot="header" class="mb-0">Активные доставки:</h5>
        <b-list-group fluid>
            <b-card-body class="text-center" v-if="deliveries.length === 0">
              Заказов не найдено
            </b-card-body>
            <b-card v-if="currentDeliveries.length === 0">
              Активных доставок на текущий момент не найдено
            </b-card>
            <b-list-group-item
              v-for="delivery in currentDeliveries"
              :key="delivery.id"
            >
                <h5>Доставка #{{delivery.id}}</h5>
                <b-card
                  v-for="order in delivery.ordersByIdDelivery.nodes"
                  :key="order.id"
                >
                    <order-block
                      v-b-toggle="'delivery-' + order.id"
                      :order="order"
                      type="courier"
                      show-map-btn
                      map-btn-cls="btn-sm"
                      :order-stages="orderStagesObj"
                    >
                    </order-block>
                    <b-collapse  :id="'delivery-' + order.id">
                        <b-card v-for="product in order.prods.nodes"
                        :key="product.id">
                            {{product.name}}
                        </b-card>
                    </b-collapse>
                    <b-btn v-if="order.status.keyword === STATUS_ORDER.SENDED" class="col-md-12" variant="success" id="change-type-payment"
                      @click="confirmOrder(order, delivery)">Подтвердить
                    </b-btn>
                </b-card>
            </b-list-group-item>
        </b-list-group>
        <div slot="footer" class="flex-grow-1">
          <h5 class="mb-0 no-select" @click="showCompletedDeliveries">Завершённые доставки &darr;</h5>
            <b-collapse class="mt-2" v-model="readyDelivery" id="readyDelivery">
                <div class="mb-3 d-flex justify-content-between align-items-center">
                  <div>
                    <b-btn :variant="completedDeliveriesDaysCount === 7 ? 'primary' : undefined" @click="getCompleteDeliveries(7)">
                      Неделя
                    </b-btn>
                    <b-btn :variant="completedDeliveriesDaysCount === 30 ? 'primary' : undefined" @click="getCompleteDeliveries(30)">
                      Месяц
                    </b-btn>
                    <b-btn :variant="completedDeliveriesDaysCount === 60 ? 'primary' : undefined" @click="getCompleteDeliveries(60)">
                      2 Месяца
                    </b-btn>
                  </div>

                  <div v-if="completedDeliveries.length">
                    {{ completedDeliveries.length }}
                  </div>

                  <b-btn variant="primary" for="example-datepicker" v-b-modal.addCourier>
                    <icon name="calendar"></icon>
                  </b-btn>
                </div>

                <b-modal
                  id="addCourier"
                  title="Выберите даты"
                  cancel-title="Отмена"
                  ok-title="Ok"
                  centered
                  @cancel="clearHistoryDates"
                  @ok="getCompleteDeliveriesByPeriod"
                >
                  <b-row>
                    <b-col>
                      <label>С</label>
                      <datepicker
                        :language="ru"
                        :monday-first="true"
                        v-model="startHistoryDate"
                        input-class="form-control datepicker"
                        placeholder="выберите дату"
                        :disabledDates="disabledDates"
                      />
                    </b-col>
                    <b-col>
                      <label>По</label>
                      <datepicker
                        :language="ru"
                        :monday-first="true"
                        v-model="endHistoryDate"
                        calendar-class="datepicker__right"
                        input-class="form-control datepicker"
                        :disabledDates="disabledDates"
                      />
                      </b-col>
                  </b-row>
                </b-modal>

                <div v-if="isCompletedDeliveriesLoading" class="d-flex justify-content-center mb-4">
                  <b-spinner variant="primary" label="Spinning" />
                </div>
                <b-card v-if="!completedDeliveries.length && !isCompletedDeliveriesLoading">
                  Завершённых доставок {{ completeDeliveriesEmptyText }}не найдено
                </b-card>
                <b-list-group-item  v-for="delivery in completedDeliveries"
                                    :key="delivery.id">
                    <h5>Доставка #{{delivery.id}}</h5>
                    <b-card v-for="order in delivery.ordersByIdDelivery.nodes"
                            :key="order.id" >
                        <order-block v-b-toggle="'delivery-' + order.id" :order="order" show-map-btn map-btn-cls="btn-sm" type="courier" :order-stages="orderStagesObj">
                        </order-block>
                        <b-collapse  :id="'delivery-' + order.id">
                            <b-card v-for="product in order.prods.nodes"
                                    :key="product.id">
                                {{product.name}}
                            </b-card>
                        </b-collapse>
                        <b-btn v-if="order.status.keyword === STATUS_ORDER.SENDED" class="col-md-12" variant="success"
                               @click="confirmOrder(order, delivery)">Подтвердить
                        </b-btn>
                        <b-btn v-if="canUpdatePayment(order)" class="col-md-12" variant="warning"
                               @click.stop="confirmOrder(order, delivery, true)">Уточнить тип оплаты
                        </b-btn>
                    </b-card>
                </b-list-group-item>
            </b-collapse>
        </div>
        <modal-payment-info ref="modalPayment" @updated-payment="updatedPayment" :order="currentOrder"/>
        </b-card>
        <b-button v-if="courierIsReturning === true" class="on-rest-point align-self-end mt-2 mb-2 w-75" variant="primary" @click="courierReturned()">Я на месте!</b-button>
    </perfect-scrollbar>
</template>

<script>
import {
  COURIERS_CURRENT_DELIVERY_QUERY,
  COURIERS_COMPLETED_DELIVERY_QUERY,
  ORDER_PAYMENT_BY_ID_ORDER_QUERY,
  STATUS_QUERY
} from '@/constants/graphql'
import {
  COURIER_IS_RETURNING,
  COURIER_RETURNED_TO_REST_POINT
} from '@/constants/graphql/courier'
import commonVar from '@/tempVariables/commonVars'
import ModalPaymentInfo from '@/components/ModalPaymentInfo'
import {STATUS_ORDER} from '@/constants/keywords'
import {geolocationPositionToJson} from '../helpers/jsHelpers'
import orderFunc from '../functionsLib/orderFunc'
import {ru} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'CourierDelivery',
  data: function () {
    return {
      ru,
      startHistoryDate: '',
      endHistoryDate: new Date(),
      currentDeliveries: [],
      completedDeliveries: [],
      completedDeliveriesDaysCount: 0,
      deliveries: [],
      orderStages: [],
      courierIsReturning: false,
      valueCash: 0,
      valueCard: 0,
      STATUS_ORDER,
      valueCardOnline: 0,
      priceConfirmOrder: null,
      answer: null,
      dateDelivery: 123,
      today: new Date(),
      currentOrder: null,
      selected: null,
      opsScroll: commonVar.opsPerfectScroll,
      readyDelivery: false,
      isCompletedDeliveriesLoading: false
    }
  },
  apollo: {
    currentDeliveries: {
      query: COURIERS_CURRENT_DELIVERY_QUERY,
      fetchPolicy: 'network-only',
      update (data) {
        return data.deliveriesCourierActive.nodes ? data.deliveriesCourierActive.nodes : []
      }
    },
    courierIsReturning: {
      query: COURIER_IS_RETURNING,
      fetchPolicy: 'network-only',
      pollInterval: 10000,
      update (data) {
        return data.courierIsReturning
      }
    },
    orderStages: {
      query: STATUS_QUERY,
      update (data) {
        return data.allStageOrders.nodes
      }
    }
  },
  methods: {
    clearHistoryDates () {
      this.startHistoryDate = ''
      this.endHistoryDate = new Date()
    },
    courierReturned () {
      navigator.geolocation.getCurrentPosition(rs => {
        let geoData = JSON.stringify(geolocationPositionToJson(rs))
        this.$apollo.mutate({
          mutation: COURIER_RETURNED_TO_REST_POINT,
          variables: {
            position: geoData
          }
        }).then((res) => {
          if (res) {
            console.log(res)
          }
        }).catch((error) => {
          alert(error.message)
          console.error(error)
        })
      }, error => {
        this.$bvModal.show('modal-enable-geopos')
        console.error(error)
      })
    },
    async getOrderPaymentInfo (idOrder) {
      return this.$apollo.query({
        query: ORDER_PAYMENT_BY_ID_ORDER_QUERY,
        fetchPolicy: 'network-only',
        variables: { idOrder }
      }).then((res) => res.data.orderPaymentByIdOrder)
    },
    async confirmOrder (order, delivery, changed) {
      const currentOrder = { ...order }
      const orderPaymentInfo = await this.getOrderPaymentInfo(order.id)

      if (orderPaymentInfo) {
        currentOrder.paymentInfo = orderPaymentInfo
      }

      if (changed === true) {
        currentOrder.paymentChanged = true
      }

      this.currentOrder = currentOrder
      this.$refs.modalPayment.showModal()
    },
    filterDateDeliveries () {
      this.today = this.$moment(this.today).format('MMMM Do YYYY')
    },
    sumPrice (price) {
      let sum = 0
      sum = price - this.valueCardOnline
      return sum
    },
    updatedPayment () {
      this.$apollo.queries.currentDeliveries.refetch()
      if (this.readyDelivery) {
        this.getCompleteDeliveries()
      }
      this.$emit('updated-payment')
    },
    canUpdatePayment (order) {
      return (order.status.keyword === STATUS_ORDER.END || order.status.keyword === STATUS_ORDER.PASSED) && order.shift !== null && order.shift.dateClosed === null
    },
    changeValueCash () {
      this.valueCard = this.priceConfirmOrder - this.valueCash
      if (this.priceConfirmOrder < this.valueCash) {
        this.valueCash = this.priceConfirmOrder
      }
    },
    changeValueCard () {
      this.valueCash = this.priceConfirmOrder - this.valueCard
      if (this.priceConfirmOrder < this.valueCard) {
        this.valueCard = this.priceConfirmOrder
      }
    },
    async refreshDeliveries () {
      this.$apollo.queries.currentDeliveries.refetch()

      if (this.readyDelivery) {
        this.getCompleteDeliveries()
      }
    },
    getCompleteDeliveriesByPeriod () {
      if (!this.startHistoryDate || !this.endHistoryDate) {
        this.clearHistoryDates()
        return
      }

      const now = new Date()
      const daysFrom = now.getDate() - (new Date(this.startHistoryDate).getDate())
      const daysTo = now.getDate() - (new Date(this.endHistoryDate).getDate())

      this.getCompleteDeliveries(daysFrom, daysTo)
      this.clearHistoryDates()
    },
    async getCompleteDeliveries (daysFrom = 0, daysTo) {
      this.completedDeliveriesDaysCount = daysFrom
      const params = []
      const now = new Date()
      const from = new Date().setDate(now.getDate() - daysFrom)
      const dateFrom = this.$moment(from).format('YYYY-MM-DD')
      params.push(dateFrom)

      if (daysTo) {
        const to = new Date().setDate(now.getDate() - daysTo)
        const dateTo = this.$moment(to).format('YYYY-MM-DD')
        params.push(dateTo)
      }

      this.isCompletedDeliveriesLoading = true
      await this.fetchCompletedDeliveries(...params)
      this.isCompletedDeliveriesLoading = false
    },
    fetchCompletedDeliveries (dateFrom, dateTo) {
      const variables = { dateFrom }

      if (dateTo) {
        variables.dateTo = dateTo
      }

      return this.$apollo.query({
        query: COURIERS_COMPLETED_DELIVERY_QUERY,
        fetchPolicy: 'network-only',
        variables
      }).then(({ data }) => {
        const completedDeliveries = data.deliveriesCourierComplete.nodes || []
        this.completedDeliveries = completedDeliveries
      }).catch(err => {
        alert(err)
      })
    },
    async createYaMapRoute () {
      if (!this.$userControl.jwtParsed || !this.orderCoords.length) {
        return
      }

      const restPoint = await orderFunc.determineRestPoint.call(this)
      let restPointLocation = []
      let coords = this.orderCoords

      if (restPoint && restPoint.location) {
        restPointLocation = Array.isArray(restPoint.location)
          ? restPoint.location
          : JSON.parse(restPoint.location)
        restPointLocation = restPointLocation.map(coord => +coord)
        coords = [restPointLocation, ...this.orderCoords]
      }

      const getUrl = (coordsUrl) => `https://yandex.ru/maps/?mode=routes&rtext=${coordsUrl}&rtt=pd&z=15` // coords 57.154786%2C65.513683~57.151544%2C65.545655~57.144826%2C65.536299
      const coordsUrl = coords.map(coords => coords.join('%2C')).join('~')
      const url = getUrl(coordsUrl)
      window.open(url, '_blank')
    },
    async showCompletedDeliveries () {
      this.readyDelivery = !this.readyDelivery

      if (this.readyDelivery) {
        this.isCompletedDeliveriesLoading = true
        await this.getCompleteDeliveries()
        this.isCompletedDeliveriesLoading = false
      }
    }
  },
  computed: {
    currentDeliveryOrders () {
      if (!this.currentDeliveries) {
        return []
      }

      const deliveryOrders = this.currentDeliveries.map(({ ordersByIdDelivery }) => ordersByIdDelivery.nodes)
      return deliveryOrders.reduce((acc, ords) => [...acc, ...ords], [])
    },
    orderCoords () {
      if (!this.currentDeliveryOrders) {
        return []
      }

      return this.currentDeliveryOrders.map(({ coords }) => (
        typeof coords === 'string' ? JSON.parse(coords) : coords
      ))
        .filter(_ => _)
    },
    orderStagesObj () {
      return this.orderStages.reduce((acc, item) => ({...acc, [item.id]: item}), {})
    },
    disabledDates () {
      const now = new Date()
      const to = new Date().setDate(now.getDate() - 60)

      return {
        to: new Date(to),
        from: new Date()
      }
    },
    completeDeliveriesEmptyText () {
      switch (this.completedDeliveriesDaysCount) {
        case (0):
          return 'за сегодня '
        case (7):
          return 'за неделю '
        case (30):
          return 'за месяц '
        case (60):
          return 'за два месяца '
        default:
          return 'за указанный период '
      }
    }
  },
  components: {
    ModalPaymentInfo
  }
}
</script>

<style lang="scss">
  .nonActive{
    background-color: #f2f5f8;
  }
  .on-rest-point {
    display: flex;
    position: relative;
    margin: 0 auto;
    text-align: center;
    overflow: hidden;
    justify-content: center;
  }

  .no-select {
    user-select: none;
  }

  .datepicker__right {
    right: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/CourierDelivery.vue